export const getSearchFormId = (type) => `${type}_search`;
